export enum EPossibleActionsEnum {
  DELETE = 'delete',
  EDIT = 'edit',
  CREATE = 'create',
  SYNC = 'sync',
  VIEW = 'view',
  RESET_PASSWORD = 'reset-password'
}
